import { SeriesOption } from 'components/DailyStatsChartCard';
import { ParsedPlayStats } from '../types';

export const CHART_STATS_SELECTOR_OPTIONS: SeriesOption<ParsedPlayStats>[] = [
  {
    value: 'plays',
    label: 'Plays',
  },
];
